"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationDialog = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_spinner_1 = require("@hopin-team/ui-spinner");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var ConfirmationDialog = function ConfirmationDialog(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      isLoading = _a.isLoading,
      isDismissible = _a.isDismissible,
      isInverse = _a.isInverse,
      isShowing = _a.isShowing,
      message = _a.message,
      onCancel = _a.onCancel,
      onClose = _a.onClose,
      onConfirm = _a.onConfirm,
      colorPattern = _a.colorPattern,
      primaryButtonText = _a.primaryButtonText,
      secondaryButtonText = _a.secondaryButtonText,
      size = _a.size,
      title = _a.title,
      withCloseButton = _a.withCloseButton,
      withSeparator = _a.withSeparator;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'ConfirmationDialog',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    type: "dialog",
    isShowing: isShowing,
    describedById: "dialog-message",
    isDismissible: isDismissible,
    onClose: onClose,
    size: "small",
    withCloseButton: withCloseButton,
    isInverse: isInverse,
    title: title,
    withSeparator: withSeparator ? 'footer' : undefined,
    footer: react_1.default.createElement(react_1.default.Fragment, null, secondaryButtonText && react_1.default.createElement(ui_button_1.Button, {
      onClick: onCancel,
      isOutlined: true,
      pattern: "primary",
      size: size,
      m: 0.5,
      mr: 0
    }, secondaryButtonText), react_1.default.createElement(ui_button_1.Button, {
      onClick: onConfirm,
      pattern: colorPattern,
      size: size,
      m: 0.5,
      disabled: isLoading
    }, isLoading ? react_1.default.createElement(ui_spinner_1.Spinner, {
      isShowing: true,
      isAssertive: true
    }) : primaryButtonText))
  }, react_1.default.createElement(ui_text_1.Text, {
    element: "p",
    id: "dialog-message",
    scale: 4,
    color: isInverse ? 'grey-300' : 'grey-600',
    mb: withSeparator ? 2 : undefined
  }, message));
};

var ConfirmationDialogWithSpace = (0, ui_helper_with_space_1.withSpace)(ConfirmationDialog);
exports.ConfirmationDialog = ConfirmationDialogWithSpace;